import Vue from "vue"
import Helpers from "@/helpers";
import config from "@/config";

let popEmojiTimer = 0;

const setPlayer = (state) => {
  let player = Helpers.localStorage.get("player");
  if (player) {
    state.playerNameSaved = true;
    state.uuid = player.id;
    state.name = player.name;
  }
};

const setName = (state, name) => {
  let player = Helpers.localStorage.get("player");
  Helpers.localStorage.set("player", { ...player, name });
  state.name = name;
};

const popEmoji = (state, emoji) => {
  if (!state.playersEmojis[emoji.playerId]) {
    Vue.set(state.playersEmojis, emoji.playerId, []);
  }
  state.playersEmojis[emoji.playerId].push(emoji.emojiName);
  clearTimeout(popEmojiTimer);
  popEmojiTimer = setTimeout(() => {
    state.playersEmojis[emoji.playerId] = [];
  }, 3000);
};

export default {
  state: {
    id: null,
    uuid: null,
    name: null,
    playerNameSaved: false,
    playersEmojis: {}
  },
  mutations: {
    setPlayer,
    setName,
    popEmoji
  },
  actions: {
    setPlayer({ state, commit, rootState }) {
      commit("setPlayer");
    },
    setPlayerName({ state, commit, rootState }, name) {
      commit("setName", name);
    },
    popEmoji({ state, commit, rootState }, emoji) {
      commit("popEmoji", emoji);
    }
  },
  getters: {}
};
